import React, { useEffect, useState } from 'react'
import { Spinner } from 'msp-components'
import { getStandingOrderProducts, useCustomer } from 'msp-integrations'
import OrderReturnAction from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderReturnAction/OrderReturnAction'
import OrderReorderAction from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderReorderAction/OrderReorderAction'
import OrderCancellationAction from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderCancellationAction/OrderCancellationAction'
import OrderSubscriptionAction from './OrderSubscriptionAction/OrderSubscriptionAction'
import { OrderActionProps } from './OrderActions.types'
import * as S from './OrderActions.styles'
import { STANDING_ORDER_PRODUCT_CATEGORY } from '@/constants'

const OrderActions = ({
  order,
  setIsCancelled,
  setAlertBoxMessage,
  setIsError
}: OrderActionProps) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const { paymentInstruments = [], getCustomerOrderProductsDetail } =
    useCustomer()
  const [subscriptionEligibleProducts, setSubscriptionEligibleProducts] =
    useState([])

  const fetchProducts = async () => {
    const products = await getStandingOrderProducts(
      order?.productItems,
      getCustomerOrderProductsDetail,
      paymentInstruments,
      STANDING_ORDER_PRODUCT_CATEGORY
    )
    if (products && products.length > 0) {
      setSubscriptionEligibleProducts(products)
    }
  }

  useEffect(() => {
    fetchProducts()
  }, [])

  return (
    <div className={S.Wrapper}>
      {isProcessing && <Spinner fullScreen />}
      <OrderReorderAction
        order={order}
        isProcessing={isProcessing}
        setIsProcessing={setIsProcessing}
      />
      {subscriptionEligibleProducts?.length > 0 && (
        <OrderSubscriptionAction
          products={subscriptionEligibleProducts}
          isProcessing={isProcessing}
          shippingAddress={order?.getShipment()?.shippingAddress}
          billingAddress={order?.billingAddress}
          paymentID={
            order?.paymentInstruments?.[0]?.c_registrationID ||
            order?.paymentInstruments?.[0]?.c_paymentResourceId
          }
          setIsProcessing={setIsProcessing}
        />
      )}
      {order.isCancellable() && (
        <OrderCancellationAction
          order={order}
          isProcessing={isProcessing}
          setIsProcessing={setIsProcessing}
          setIsCancelled={setIsCancelled}
          setAlertBoxMessage={setAlertBoxMessage}
          setIsError={setIsError}
        />
      )}
      {order.isReturnable() && <OrderReturnAction order={order} />}
    </div>
  )
}

export default OrderActions
